export default {
  sectionTitle: {
    size: "lg",
    fontWeight: "semibold",
    fontFamily: "heading",
    color: "text",
  },
  heading: {
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "bold",
    letterSpacing: "-0.015em",
    lineHeight: "1.24",
    fontSize: { base: "2rem", md: "3.5rem" },
    color: "text",
  },
  "heading-2": {
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "bold",
    letterSpacing: "-0.015em",
    lineHeight: "1.24",
    fontSize: { base: "1.75rem", md: "2.75rem" },
    color: "text",
  },
  caps: {
    textTransform: "uppercase",
    fontSize: "xs",
    letterSpacing: "widest",
    fontWeight: "bold",
    color: "text",
  },
  postCardLink: {
    color: "currentColor",
    _hover: {
      color: "currentColor",
      textDecoration: "none",
    },
    display: "inline-block",
  },
};
